import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import { Calendar } from "primereact/calendar";
import { styled } from "@mui/material/styles";
import { locale, addLocale } from "primereact/api";
import { toZonedTime  } from "date-fns-tz";

addLocale("es", {
  firstDayOfWeek: 1,
  dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
  dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  dayNamesMin: ["D", "L", "Ma", "Mi", "J", "V", "S"],
  monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
  monthNamesShort: ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"],
  today: "Hoy",
  clear: "Limpiar"
});

const colombiaTimeZone = 'America/Bogota';

const FormCalendar = ({
  name,
  control,
  label,
  defaultValue,
  width,
  onChange,
  formLabel,
  error,
  minDate = null,
  maxDate = null,
  margin,
  disabled = false,
  disableWeekends = false,
  disabledDates = []
}) => {
  useEffect(() => {
    locale("es");
  }, []);

  const normalizeDate = (date) => {
    const zoned = toZonedTime(date, colombiaTimeZone);
    return new Date(zoned.getFullYear(), zoned.getMonth(), zoned.getDate());
  };

  const parsedDisabledDates = disabledDates.map(normalizeDate);

  const isDateDisabled = (date) => {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    if (disableWeekends && (d.getDay() === 0 || d.getDay() === 6)) {
      return true;
    }

    return parsedDisabledDates.some(
      (disabled) =>
        disabled.getDate() === d.getDate() &&
        disabled.getMonth() === d.getMonth() &&
        disabled.getFullYear() === d.getFullYear()
    );
  };

  const StyledCalendar = styled(({ width, error, ...props }) => (
    <Calendar {...props} baseZIndex={2000} />
  ))(() => ({
    width: width || "100%",
    margin: margin || "0 10px",
    borderRadius: "6px",
    height: "40px",
    borderColor: error ? "red" : "#c4c4c4",
    border: `1px solid ${error ? "red" : "#c4c4c4"}`,
    "& .p-inputtext": {
      padding: "4.5px"
    },
    "&:hover": {
      borderColor: "black"
    }
  }));

  return (
    <div style={{ minWidth: 120 }}>
      {label && <p className="text-form-label">{label}</p>}

      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue || null}
        render={({ field }) => (
          <>
            <StyledCalendar
              {...field}
              value={field.value || null}
              onChange={(e) => {
                const zoned = toZonedTime(e.value, colombiaTimeZone);
                field.onChange(zoned);
                onChange && onChange(zoned);
              }}
              placeholder={formLabel}
              dateFormat="dd/M/yy"
              locale="es"
              disabled={disabled}
              showIcon
              minDate={minDate ? normalizeDate(minDate) : undefined}
              maxDate={maxDate ? normalizeDate(maxDate) : undefined}
              disabledDates={parsedDisabledDates}
              isDateDisabled={isDateDisabled}
            />
            {error && <p className="error-message">{error.message}</p>}
          </>
        )}
      />
    </div>
  );
};

export default FormCalendar;
